class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }


  // loadProductRecommendationsIntoSection() {
  //   // Look for an element with class 'product-recommendations'
  //   var productRecommendationsSection = document.querySelector(".product-recommendations");
  //   if (productRecommendationsSection === null) { return; }
  //   // Read product id from data attribute
  //   var productId = productRecommendationsSection.dataset.productId;
  //   // Read limit from data attribute
  //   var limit = 4;
  //   // Build request URL
  //   var requestUrl = "/recommendations/products?section_id=cart-drawer&limit="+limit+"&product_id=8627632341335&intent=related";
  //   // Create request and submit it using Ajax
  //   var request = new XMLHttpRequest();
  //   request.open("GET", requestUrl);
  //   request.onload = function() {
  //     if (request.status >= 200 && request.status < 300) {
  //       var container = document.createElement("div");
  //       container.innerHTML = request.response;
  //       console.log(request.response)
  //       productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
  //       
  //     }
  //   };
  //   request.send();
  // };

    
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    // Hide slide out cart upsell
    if (document.querySelector('[data-slide-out-upsell-container]')) {
      document.querySelector('[data-slide-out-upsell-container]').style.transform = 'translateY(100%)';
    }

    this.addEventListener('transitionend',() => {
      document.querySelectorAll(".upsell-add-to-cart-button").forEach((button) => {
        button.addEventListener("click", (event) => {
          const productID = event.target.value;
          upsellProductAddtoCart(productID);
        });
      });
      const swiperDrawer = new Swiper('.product-recommendations-box', {
        spaceBetween: 10,
        slidesperView: 1,
        autoplay: {
          delay: 999999,
        },
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".cart-drawer-dots",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        }
      });

      swiperDrawer.autoplay.stop();

      const swiperRewards = new Swiper('.product-rewards-box', {
        spaceBetween: 10,
        slidesperView: 1,
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
        pagination: {
          el: ".cart-drawer-rewards-dots",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        }
      });
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');
    window.dispatchEvent(new CustomEvent('cartDrawerOpened'));
  }

  close() {
    const getCartItemCount = document.querySelector('[data-slide-out-upsell-container]').attributes['data-cart-item'].value;
    
    const menuDrawer = document.getElementById("Details-menu-drawer-container");
    if (menuDrawer && menuDrawer.hasAttribute("open")) {
        return;
    }

    if (parseInt(getCartItemCount) !== 0) {
      document.querySelector('[data-slide-out-upsell-container]').style.transform = 'translateY(0)';
    }

    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log("Parsed State: ", parsedState)
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Auto-open cart drawer if "?cart=true" is in the URL
window.addEventListener('DOMContentLoaded', () => {
  const url = new URL(window.location.href);
  const shouldOpenCart = url.searchParams.get('cart') === 'true';

  if (shouldOpenCart) {
    const cartDrawerElement = document.querySelector('cart-drawer');
    if (cartDrawerElement) {
      cartDrawerElement.open();

      // Remove the query parameter without reloading the page
      url.searchParams.delete('cart');
      const newUrl = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
      window.history.replaceState({}, '', newUrl);
    }
  }
});

